module.exports = __webpack_public_path__ + "static/media/mnzlogo.7f98e833.svg";